import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./LightShowMobileWeb.css";
import { socket } from "../../socket";
import { detectionThreshold } from "../LightShow/Common";
import Logo from "./Logo";
import { AD_TYPES } from "../AdsSetupManager/functions";
import LightShowEffects from "./LightShowEffects";
import TorchShow from "./TorchShow";
import { getLightShowSettingsForEvent } from "../Games/networkCalls/networkCalls";
import { CDN_URLS } from "../../constants";
import Countdown from "./Countdown";

const beatThreshold = 15;
const LightShowMobileWeb = ({ eventIdfromPageParams }) => {
  const location = useLocation();
  const [advertsData, setAdvertsData] = useState([]);
  const [savedSettings, setSavedSettings] = useState(null);

  const getPostEventAdData = () => {
    let data = null;
    if (advertsData && advertsData.length) {
      const postEventAd = advertsData.find(
        (ad) => ad?.adType === AD_TYPES.LIGHT_SHOW
      );
      if (postEventAd) {
        data = postEventAd;
      }
      return data;
    }
  };
  const [postEventAd, setPostEventAd] = useState(getPostEventAdData);
  const [showAd, setShowAd] = useState(() => {
    return !socket.connected;
  });
  const [showLogo, setShowLogo] = useState(true);
  const [show, setShow] = useState(null);

  const [pulse, setPulse] = useState(null);
  const [adSrc, setAdSrc] = useState("");
  const getEventSettings = async (eventId) => {
    const response = await getLightShowSettingsForEvent(eventId);
    if (response?.lightShowSettings) {
      setSavedSettings(response.lightShowSettings);
    }
    if (response?.adverts) {
      setAdvertsData(response.adverts);
    } else {
      setAdvertsData([]);
    }
  };
  const logErrors = () => {
    socket.on("connect_error", (err) => {
      // the reason of the error, for example "xhr poll error"
      console.log(err.message);

      // some additional description, for example the status code of the initial HTTP response
      console.log(err.description);

      // some additional context, for example the XMLHttpRequest object
      console.log(err.context);
    });
  };

  const onDisconnect = () => {
    switchOffFlashlight();
    setPulse(false);
    setShow(null);
  };

  const switchOffFlashlight = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({
      video: { facingMode: "environment" },
    });
    const track = stream.getVideoTracks()[0];
    const capabilities = track.getCapabilities();

    if (capabilities.torch) {
      await track.applyConstraints({
        advanced: [{ torch: false }],
      });
      track.stop();
    }
  };
  const onDataArray = ({ triggerDisconnect, dataArray, settings, eventId }) => {
    if (triggerDisconnect) {
      onDisconnect();
      if (!eventId) {
        setShowLogo(false);
        setShowAd(true);
      } else {
        setShowAd(false);
        setShowLogo(true);
      }
      return;
    }
    if (eventId !== eventIdfromPageParams) {
      return;
    }

    if (dataArray !== null && dataArray !== undefined && settings) {
      const intensity = dataArray;
      const threshold =
        settings.targetFrequency === 0 ? beatThreshold - 1 : detectionThreshold;
      const show = settings;
      // Play on audience phone screen
      setPulse(intensity > threshold);
      setShow(show);
      setShowAd(false);
      setShowLogo(true);
    }
  };

  useEffect(() => {
    setPostEventAd(getPostEventAdData);
  }, [advertsData]);
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const eventId = eventIdfromPageParams || searchParams.get("eventId");

    if (!eventId) {
      console.log("Event ID is missing");
      return;
    }
    getEventSettings(eventId);

    socket.connect();
    socket.on("connect", () => {
      if (eventId) {
        socket.emit("joinRoom", eventId);
      }
    });
    socket.on("dataArray", onDataArray);
    socket.on("disconnect", onDisconnect);

    logErrors();
    return () => {
      socket.disconnect();
      socket.off("dataArray", onDataArray);
      socket.off("disconnect", onDisconnect);
    };
  }, [eventIdfromPageParams, location.search]);
  useEffect(() => {
    if (pulse === false) {
      switchOffFlashlight();
    }
  }, [pulse]);

  useEffect(() => {
    if (postEventAd) {
      if (postEventAd.mimeType.includes("video")) {
        setAdSrc(postEventAd?.adMediaUrl || CDN_URLS.LIGHTSHOW_DEFAULT_AD);
      } else if (postEventAd.mimeType.includes("image")) {
        setAdSrc(postEventAd?.adMediaUrl || CDN_URLS.LIGHTSHOW_DEFAULT_AD);
      }
    } else if (postEventAd === null) {
      setAdSrc(CDN_URLS.LIGHTSHOW_DEFAULT_AD);
    }
  }, [postEventAd]);
  const getAd = () => {
    if (!showAd) {
      return null;
    }
    if (!postEventAd) {
      return (
        <div className="lsAdContainer">
          <video
            src={adSrc}
            playsInline
            autoPlay
            loop
            muted
            className="lsAdMedia"
          />
        </div>
      );
    }
    if (postEventAd.mimeType.includes("video")) {
      return (
        <div className="lsAdContainer">
          <video
            src={adSrc}
            playsInline
            autoPlay
            loop
            muted
            className="lsAdMedia"
          />
        </div>
      );
    } else if (postEventAd.mimeType.includes("image")) {
      return (
        <div className="lsAdContainer">
          <img src={adSrc} className="lsAdMedia" alt="Ad" />
        </div>
      );
    }

    return null;
  };
  const renderContent = () => {
    return (
      <div className="light-show-preview-web-app">
        {pulse && show ? (
          show?.isTorchShow ? (
            <TorchShow
              animationDuration={
                show?.effect === 5 ? 0 : show?.animationDuration
              }
            />
          ) : (
            <LightShowEffects
              switchOffFlashlight={switchOffFlashlight}
              {...show}
            />
          )
        ) : null}
        {showLogo &&
        !showAd &&
        savedSettings &&
        savedSettings.mediaForAudienceScreen ? (
          <Logo {...savedSettings} />
        ) : null}
        {getAd()}
        {savedSettings &&
          savedSettings?.startTime &&
          savedSettings?.isShowCountDown &&
          !pulse && <Countdown startTime={savedSettings.startTime} />}
      </div>
    );
  };

  return <div className="light-show-web-app-container">{renderContent()}</div>;
};
export default LightShowMobileWeb;
